
(function () {
    const loginModal = document.querySelector('.modal-login');
    const loginForm = document.querySelector('.login-form');
    const resetForm = document.querySelector('.password-reset-form');
    const forgotLink = document.querySelector('.forgot-link');
    const loginBtn = document.querySelector('.btn-login');
    let loginModalOpen = false;

    if (loginModal) {
        document.querySelectorAll('.login-btn').forEach((login) => {
            login.addEventListener('click', () => {
                loginModal.classList.toggle('active');
                setTimeout(function () {
                    loginModalOpen = !loginModalOpen;
                }, 10);
            });
        });

        document.addEventListener('click', (e) => {
            if (!loginModal.contains(e.target) && loginModalOpen) {
                loginModal.classList.remove('active');
                loginModalOpen = false;
            }
        });

        if (forgotLink) {
            forgotLink.addEventListener('click', () => {
                loginForm.classList.add('hidden');
                resetForm.classList.remove('hidden');
            });
        }

        if (loginBtn) {
            loginBtn.addEventListener('click', () => {
                loginForm.classList.remove('hidden');
                resetForm.classList.add('hidden');
            });
        }
    }
}());